import "assets/scss/app.scss";
import Teams from "views/Teams/Teams.js";
import UserDashboard from "views/UserDashboard/UserDashboard";
import UserProfile from "views/UserProfile/UserProfile.js";
import TeamPollList from "views/Poll/TeamPollList.js";
import Chats from "views/Chats/Chats";
import Chat from "components";
import UnAuthorizedTeams from "views/Integrations/Teams/UnAuthorizedTeams";
import SearchedContent from "views/SearchedContent/SearchedContent";
import TeamsConnectors from "views/MicrosoftTeams/TeamDashboard/TeamsConnectors/TeamsConnectors";
import CompanyPost from "views/CompanyPost";
import SupportTicket from "views/SupportTicket/SupportTicket";

const dashboardRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "Dashboard",
    component: UserDashboard,
    layout: "",
  },
  {
    path: "/search",
    name: "Search",
    icon: "",
    hideFromSidebar: true,
    component: SearchedContent,
    layout: "",
  },
  {
    path: "/private-chat/:user_id/chat",
    name: "",
    icon: "",
    hideFromSidebar: true,
    component: Chat,
    layout: "",
  },
  {
    path: "/teams",
    name: "Teams",
    icon: "Team",
    component: Teams,
    layout: "",
  },
  {
    path: "/un-authorize",
    name: "UnauthenticatedRoute",
    hideFromSidebar: true,
    component: UnAuthorizedTeams,
    layout: "",
  },
  {
    path: "/poll",
    name: "Polls",
    icon: "Poll",
    component: TeamPollList,
    layout: "",
  },
  {
    path: "/company/:companyId/post/:postId",
    name: "Company",
    icon: "innovation",
    hideFromSidebar: true,
    component: CompanyPost,
    layout: "",
  },
  {
    path: "/chat",
    name: "Lets Chat",
    icon: "Chat",
    dropDown: true,
    component: Chats,
    layout: "",
  },
  {
    path: "/support/ticket",
    name: "Support Ticket",
    icon: "FAQ",
    dropDown: true,
    component: SupportTicket,
    layout: "",
  },
  {
    path: "/profile/:user_id",
    name: "User Profile",
    component: UserProfile,
    hideFromSidebar: true,
    layout: "",
  },
  {
    path: "/teams-connector",
    name: "Webhook",
    component: TeamsConnectors,
    hideFromSidebar: true,
    layout: "",
  },
];

export default dashboardRoutes;
